<template>
    <div class="header__top"  :style="config ? { backgroundColor: config.background_color  + ' !important' }: {}">
      <button 
          @click="closeChat" 
          @keyup.enter="closeChat" 
          @keyup.space="closeChat" 
          class="action-icon close"
          :aria-label="$gettext('Cerrar chat')"  
          tabindex="0">
        </button>
      <div>
<!--        <p v-if="isUserLogged" v-translate>Hola <br><span>{{name}}</span></p>-->
        <p class="bold__greeting" tabindex="0">{{ $gettext('Tema:') + ' ' + currentType }}</p>
      </div>
    </div>
  </template>
  
  <script>
  import {mapGetters} from "vuex";

  export default {
    props: ['isUserLogged', 'currentType', 'name','chatWindowStatusMessage'],
    methods: {
      closeChat() {
        this.$store.commit('setGreetingText', "Hej!");
        this.$emit('closeChat');
      }
    },
    computed: {
      ...mapGetters(['config'])
    }
  }
  </script>